<template>
  <div class="container" v-title :data-title="$t('i18n.exposureTable')">
    <div id="outer-title">{{ $t("i18n.exposureTable") }}</div>
    <div v-loading="loading">
      <jl-table
        :tableData="tableData"
        @handleEdit="handleEdit"
        @handleDelete="handleDelete"
        @getEditData="getEditData"
        @init="init"
        :options="options"
        :columns="columns"
        :operates="operates"
        :total="total"
        :height="$defined.HEIGHT - 360 + 'px'"
      >
      </jl-table>
    </div>
    <el-dialog
      :title="$t('i18n.details')"
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-image :src="imgSrc"></el-image>
    </el-dialog>
  </div>
</template>
<script>
import { reactive, toRefs, getCurrentInstance } from "vue";
import { useI18n } from "vue-i18n";
import jlTable from "../../components/table";
export default {
  name: "Exposure",
  components: {
    jlTable,
  },
  setup(props, { emit }) {
    emit("public_header", true);
    const { proxy } = getCurrentInstance();
    const { t } = useI18n();
    const state = reactive({
      formInline: {
        pageNumber: 1,
        pageSize: 10,
      },
      dialogFormVisible: false,
      // table数据
      tableData: [],
      options: {
        // table 的参数
        isAdd: proxy.$defined.btnPermission("添加曝光事件"), // 是否启用新增功能
        isEdit: proxy.$defined.btnPermission("编辑曝光事件"), // 是否启用编辑功能
        isDelete: proxy.$defined.btnPermission("删除曝光事件"), // 是否启用删除功能
        highlightCurrentRow: false, // 是否支持当前行高亮显示
        multiSelect: false, // 是否支持列表项选中功能
        pageShow: true, // 是否翻页
      },
      columns: [
        // 需要展示的列
        {
          prop: "accountName",
          label: "accountName",
          align: "center",
          search: true,
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "adverseType",
          label: "adverseType",
          align: "center",
          search: true,
          type: "select",
          props: { label: "locale", value: "id" },
          data: [
            { id: 10, locale: "violation" },
            { id: 20, locale: "serVio" },
          ],
          rules: [{ required: true, message: t("i18n.input") }],
          formatter: (row) => {
            let val = row.adverseType == 10 ? "violation" : "serVio";
            return t("i18n." + val);
          },
        },
        {
          prop: "exposureEvent",
          label: "exposureEvent",
          align: "left",
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "eventStatus",
          label: "eventStatus",
          align: "center",
          type: "select",
          props: { label: "locale", value: "id" },
          data: [
            { id: 10, locale: "unfinished" },
            { id: 20, locale: "finished" },
          ],
          rules: [{ required: true, message: t("i18n.input") }],
          formatter: (row) => {
            let val = row.eventStatus == 10 ? "unfinished" : "finished";
            return t("i18n." + val);
          },
        },
        {
          prop: "description",
          label: "details",
          align: "center",
          type: "upload",
          action: "exposureDetails",
          limit: "1",
          value: [],
          tip: "只能上传jpg/png文件",
          formatter: (row) => {
            if (row.description) {
              return `<img src="${proxy.$defined.imgUrl + row.description}"
                style="width: 100px; height: 20px" />`;
            } else {
              return "-";
            }
          },
          method: (row) => {
            state.dialogFormVisible = true;
            state.imgSrc = proxy.$defined.imgUrl + row.description;
          },
        },
      ],
      operates: {
        // 列操作按钮
        width: 140,
        fixed: "right",
        list: [],
      },
      total: 0,
      loading: true,
      editData: {},
      imgSrc: "",
    });

    const init = async (params) => {
      state.loading = true;
      const { data } = await proxy.$api.supervision.exposurePages(params);
      state.tableData = data.records;
      state.total = data.total;
      state.loading = false;
    };

    const handleEdit = async (val, pages) => {
      // 新增/编辑数据
      let msg = val.id ? "edit" : "new";
      if (val.id) {
        for (let k in val) {
          if (val[k] !== undefined) {
            state.editData[k] = val[k];
          }
        }
        val = JSON.parse(JSON.stringify(state.editData));
      }
      val.id
        ? await proxy.$api.supervision.editExposure(val.id, val)
        : await proxy.$api.supervision.addExposure(val);
      proxy.$defined.tip(t("i18n." + msg) + t("i18n.success"), "success");
      // 初始化 刷新
      init(pages);
    };

    const handleDelete = (row, pages) => {
      proxy.$api.supervision.delExposure(row.id).then(() => {
        init(pages);
        proxy.$defined.tip(t("i18n.delete") + t("i18n.success"), "success");
      });
    };

    const getEditData = (row) => {
      state.editData = row;
    };

    return {
      ...toRefs(state),
      handleEdit,
      init,
      handleDelete,
      getEditData,
    };
  },
};
</script>
